export const EXPORT_CONSTANTS = {
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  },
} as const;

export enum EXPORT_STATUS {
  COMPLETED = "Completed",
  IN_PROGRESS = "InProgress",
  FAILED = "Failed",
}

export enum EXPORT_TYPE {
  COMPANY_LIST = "companyList",
  COMPANY_PROFILE = "companyProfile",
}
